<template>
    <div>
        <!-- Peso/Altura Prescrição -->
        <div class="modal fade" id="pesoAlturaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="receita">
                    <div class="modal-header">
                        <h5 class="modal-title">Peso/Altura</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info" v-if="receita && receita.anamnese && receita.anamnese.atendimento_procedimento && receita.anamnese.atendimento_procedimento.atendimento && receita.anamnese.atendimento_procedimento.atendimento.paciente">
                            <div class="lead">{{ receita.anamnese.atendimento_procedimento.atendimento.paciente.st_nome }}</div>
                            <div>#{{ receita.anamnese.atendimento_procedimento.id_atendimento }}</div>
                            <div v-if="receita.titulo">{{ receita.titulo }}</div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                              <az-input
                                sizing="sm"
                                type="date"
                                label="Data da Aferição"
                                required
                                :validate="validate"
                                v-model="receita.dt_pesagem">
                              </az-input>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Peso"
                                :validate="validate"
                                v-model="receita.in_peso">
                                <template v-slot:buttonposb>
                                  <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">kg</span>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Altura"
                                :validate="validate"
                                v-model="receita.in_altura">
                                <template v-slot:buttonposb>
                                  <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">m</span>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Superfície Corpórea (SC)"
                                :validate="validate"
                                :edicao="false"
                                v-model="sc">
                                <template v-slot:buttonposb>
                                  <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">m2</span>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="IMC"
                                :validate="validate"
                                :edicao="false"
                                v-model="imc" />
                            </div>
                        </div>
                        <div class="form-row" v-if="tem_auc">
                            <div class="col col-12">
                              <az-input
                                sizing="sm"
                                type="number"
                                label="Creatinina"
                                :validate="validate"
                                v-model="receita.dc_creatinina">
                                <template v-slot:buttonposb>
                                  <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon2">mg/dL</span>
                                    <a href="https://reference.medscape.com/calculator/169/carboplatin-auc-dosing-calvert" class="btn btn-outline-secondary" target="_blank">
                                        <i class="fa fa-calculator" aria-hidden="true"></i>
                                    </a>
                                  </div>
                                </template>
                              </az-input>
                            </div>
                        </div>
                        
                        <pre v-if="false">{{ receita }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            receita: null, 
            validate: false, 
        }
    },

    components: { 
        AzInput, 
        AzSubmit
    },

    computed: { 
        imc: {
            get() {
                if (!this.receita || !this.receita.in_altura || !this.receita.in_peso ) return;

                return Math.round(this.receita.in_peso / ( this.receita.in_altura * this.receita.in_altura ));
            },

            set(value) {
                this.receita.imc = value;
            },
        },

        sc: {
            get() {
                if ( !this.receita || !this.receita.in_peso || !this.receita.in_altura )
                return;

                return Math.round(
                        Math.sqrt(Number(this.receita.in_altura * 100) * Number(this.receita.in_peso) / 3600) * 100
                    ) / 100;
            },

            set(value) {
                this.receita.sc = value;
            },
        },

        tem_auc: function () { 
            if ( !this.receita ) { 
                return false; 
            }

            let tem = false;

            if ( this.receita.items ) { 
                this.receita.items.forEach(element => {
                    if ( element.apresentacao && element.apresentacao.st_calc == 'AUC' ) { 
                        tem = true;
                    }

                    if ( element.diluidos ) { 
                        element.diluidos.forEach(diluido => {
                            if ( diluido.apresentacao && diluido.apresentacao.st_calc == 'AUC' ) { 
                                tem = true;
                            }
                        });   
                    }
                });
            }

            return tem;
        }
    },

    methods: { 
        abrir (receita) { 
            this.validate = false; 
            this.receita = _.cloneDeep(receita); 

            $('#pesoAlturaModal').modal('show');
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'pep', 
                func: 'peso_altura', 
                dados: { 
                    id_receita: this.receita.id_receita, 
                    in_peso: this.receita.in_peso,
                    in_altura: this.receita.in_altura,
                    dt_pesagem: this.receita.dt_pesagem,
                    dc_creatinina: this.receita.dc_creatinina,
                },
                toast: true, 
                modal: 'pesoAlturaModal',
                callback: () => {
                    this.$emit('refresh');
                },
            });
        }
    }, 
}
</script>
